export default function ({ route, redirect }) {
  if (route && route.path === '/shop') {
    return redirect('/orders')
  }
}
